<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord"></vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord"></vs-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push(`/company/edit/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Perhatian',
        text: `Anda akan menghapus "${this.params.data.name}" ?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const self = this
      this.$store.dispatch('company/deleteCompany', this.params.data.id)
        .then(function () {
          self.params.getCompany()
          self.showDeleteSuccess()
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Oops..',
            text: err
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Berhasil',
        text: 'Perusahaan terpilih berhasil dihapus'
      })
    }
  }
}
</script>
